import { isNumber } from 'lodash';

// TODO: Remove this function, this is not supported by all browsers, we should use normalizeOpacity instead
export function computeOpacity(opacity?: number) {
  if (!isNumber(opacity)) return '';

  return `${opacity}%`;
}

export function normalizeOpacity(opacity?: number) {
  if (!isNumber(opacity)) return 1;

  return opacity / 100;
}
